import script from "./ErrorPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPopup.vue?vue&type=script&setup=true&lang=js"

import "./ErrorPopup.vue?vue&type=style&index=0&id=010c2e44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010c2e44"]])

export default __exports__